import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CustomerAccountDialogComponent } from './customer-account-dialog.component';
import { CustomerAccountDialogService } from './customer-account-dialog-service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { EnrollEmailDuplicateModule } from '../../enrollEmailDuplicate/enroll-email-duplicate.module';
import { AppMaterialModule } from '../../appMaterial/app-material.module';
import { RouterModule } from '@angular/router';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [
    AppMaterialModule,
    FormsModule,
    EnrollEmailDuplicateModule,
    CommonModule,
    MatButtonModule,
    MatInputModule,
    RouterModule,
    TextMaskModule,
  ],
  exports: [CustomerAccountDialogComponent],
  declarations: [CustomerAccountDialogComponent],
  providers: [CustomerAccountDialogService],
  entryComponents: [CustomerAccountDialogComponent],
})
export class CustomerAccountDialogModule {}
